/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as PopoverDefault } from './popover-default.story';
export { default as PopoverNoButtonWrapper } from './popover-no-button-wrapper.story';
export { default as PopoverSeparateAnchor } from './popover-separate-anchor.story';
export { default as PopoverInDialog } from './popover-in-dialog.story';
export { default as PopoverCustomOffset } from './popover-custom-offset.story';
export { default as PopoverControlled } from './popover-controlled.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import PopoverControlledSrcRaw from './popover-controlled.story?raw';
import PopoverCustomOffsetSrcRaw from './popover-custom-offset.story?raw';
import PopoverDefaultSrcRaw from './popover-default.story?raw';
import PopoverInDialogSrcRaw from './popover-in-dialog.story?raw';
import PopoverNoButtonWrapperSrcRaw from './popover-no-button-wrapper.story?raw';
import PopoverSeparateAnchorSrcRaw from './popover-separate-anchor.story?raw';

export const PopoverDefaultSrc = removeLicenseHeader(PopoverDefaultSrcRaw);
export const PopoverNoButtonWrapperSrc = removeLicenseHeader(
  PopoverNoButtonWrapperSrcRaw,
);
export const PopoverSeparateAnchorSrc = removeLicenseHeader(
  PopoverSeparateAnchorSrcRaw,
);
export const PopoverInDialogSrc = removeLicenseHeader(PopoverInDialogSrcRaw);
export const PopoverCustomOffsetSrc = removeLicenseHeader(
  PopoverCustomOffsetSrcRaw,
);
export const PopoverControlledSrc = removeLicenseHeader(
  PopoverControlledSrcRaw,
);
